// extracted by mini-css-extract-plugin
export default {"app":"tKOBSxGQ","userMenu":"Gj7actQZ","auto_de_slideRight":"z6hgAoLT"};